import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Certificate, CertificateDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getCertificates(): Observable<Certificate[]> {
        return this.httpClient.get<CertificateDto[]>('certificates').pipe(mapDto((response) => response.map((item) => new Certificate(item))));
    }
}
